import { ChangeEvent, FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { SportCompetitionScheduleQueryResponse } from '@hooks/useSportEntitySchedule/types'
import SvgIcon from '@components/SvgIcon'

type DropdownProps = {
  rounds: SportCompetitionScheduleQueryResponse['rounds']
  onSelect: (value: string) => void
  selectedRoundId: string
}

const Wrapper = styled.div`
  position: relative;
`
const DropdownOption = styled.option`
  ${({
    theme: {
      colors: { fillDefault, fillStrong, textDefault },
      spacing: { spacing16, spacing24 },
      typography: {
        catchword: {
          large2: { bundledCSS: large2Catchword },
        },
      },
    },
  }) => css`
    padding: ${spacing16} ${spacing24};
    cursor: pointer;
    background-color: ${fillDefault};
    color: ${textDefault};
    text-align: left;
    ${large2Catchword};

    &::checkmark {
      display: none;
    }

    &:hover {
      background-color: ${fillStrong};
    }
  `}
`

const ChevronIcon = styled(SvgIcon)`
  ${({
    theme: {
      spacing: { spacing24 },
      colors: { iconDefault },
    },
  }) => css`
    position: absolute;
    top: ${spacing24};
    right: ${spacing24};
    color: ${iconDefault};
    z-index: -1;
  `}
`
const DropdownBox = styled.select`
  ${({
    theme: {
      spacing: { spacing4, spacing8, spacing16, spacing24 },
      colors: { fillDefault, strokeDefault, textDefault },
      typography: {
        headings: {
          xsmall: { bundledCSS: xsmallHeading },
        },
      },
    },
  }) => css`
    appearance: none;
    width: 100%;
    border: 1px solid ${strokeDefault};
    border-radius: ${spacing4};
    margin: ${spacing8} 0;
    padding: ${spacing16} ${spacing24};
    background-color: transparent;
    color: ${textDefault};
    text-align: left;
    ${xsmallHeading};

    &:focus-visible {
      outline: none;
    }

    &::picker(select) {
      appearance: base-select;
      background-color: ${fillDefault};
      border-radius: ${spacing4};
      margin-top: ${spacing8};
      border: 1px solid ${strokeDefault};
    }
    &::picker-icon {
      display: none;
    }
  `}
`

const Dropdown: FunctionComponent<DropdownProps> = ({
  rounds,
  selectedRoundId,
  onSelect,
}) => (
  <Wrapper>
    <DropdownBox
      onChange={(event: ChangeEvent<HTMLSelectElement>) =>
        onSelect(event.target.value)
      }
      value={selectedRoundId}
    >
      {rounds.map(({ id, name }) => (
        <DropdownOption key={id} value={id}>
          {name}
        </DropdownOption>
      ))}
    </DropdownBox>
    <ChevronIcon iconName="chevron-down" size={24} />
  </Wrapper>
)

export default Dropdown
